import type { SupportedMediaStyleKey } from "replo-runtime/shared/utils/breakpoints";
import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

export type DraggingDirections = "negative" | "positive";

export const getCursor = (
  draggingType?: "horizontal" | "vertical",
  draggingDirection?: DraggingDirections,
) => {
  if (draggingType === "horizontal") {
    switch (draggingDirection) {
      case "positive":
        return "e-resize";
      case "negative":
        return "w-resize";
      default:
        return "ew-resize";
    }
  } else if (draggingType === "vertical") {
    switch (draggingDirection) {
      case "positive":
        return "n-resize";
      case "negative":
        return "s-resize";
      default:
        return "ns-resize";
    }
  }
  // NOTE (Sebas, 2024-11-06): This is needed to apply the cursor from the parent element
  // in the draggable component.
  return "inherit";
};

export const canvasToStyleMap = {
  desktop: "style",
  tablet: "style@md",
  mobile: "style@sm",
} satisfies Record<EditorCanvas, SupportedMediaStyleKey>;
